export default __webpack_public_path__ + "static/LOGO-SNIPER-OLD-2a9fde1f1acb5943fb67812529de18f8.png";